import React from 'react';
import styles from './SearchBar.module.scss';

interface CompPros {
  searchFilters: { [k: string]: any };
  onFilterTextInputChange: (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
}
const SearchBar = ({
  searchFilters,
  onFilterTextInputChange,
  name,
}: CompPros): React.ReactElement => {
  return (
    <div className={styles.searchInputContainer}>
      <div className={styles.search}>
        <i className="bi bi-search"></i>
        <input
          type="text"
          placeholder={name}
          value={searchFilters.query || ''}
          onChange={onFilterTextInputChange('query')}
        />
      </div>
    </div>
  );
};

export default SearchBar;
